//get accesspoint id from the url, call the api to get the hub relays for the accesspoint id and show in a primereact datatable
import React, { useState, useEffect, useRef  } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { config } from '../config.js';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import { Tag } from 'primereact/tag';
import { Messages } from 'primereact/messages';
import { Card } from 'primereact/card';
import Container from 'react-bootstrap/Container';
import {InputSwitch} from 'primereact/inputswitch';
import { useAuth } from '../contexts/AuthContext.js';
import { Toolbar } from 'primereact/toolbar';
import { Dropdown } from 'primereact/dropdown';
import useStatusPageScript from '../hooks/useStatusPageScript.js';
import AccessState from './AccessState';
import usePageAccessRedirect from '../hooks/usePageAccessRedirect';

import '../config.js'

const Groups = () => {
  // Load the status page script
  useStatusPageScript();
  
    const { typeId } = useParams();
    const [groups, setGroups] = useState([]);
    const {relayStatus, setRelayStatus} = useState([]);
    const [hubRelay, setHubRelay] = useState({});
    const [displayDialog, setDisplayDialog] = useState(false);
    const [displayDialogDelete, setDisplayDialogDelete] = useState(false);
    const [newHubRelay, setNewHubRelay] = useState(false);
    const [newGroupName, setNewGroupName] = useState('');
    const [editGroupId, setEditGroupId] = useState(0);
    const [newBlockedBy, setNewBlockedBy] = useState('');
    const [newExtra, setNewExtra] = useState('');
    const [blockingGroups, setBlockingGroups] = useState([]);
    const [newBlockingTime, setNewBlockingTime] = useState(0);
    const [deniedResponse, setDeniedResponse] = useState('Your access has been blocked by the Anti-passback rule.');
    const [editAllowed, setEditAllowed] = useState(true);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [submitted, setSubmitted] = useState(false);
    const toast = useRef(null);
    const toastBC = useRef(null);
    const msgs = useRef(null);
    const [loading, setLoading] = useState(true);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const dt = useRef(null);
    const navigate = useNavigate();
    const [statuses] = useState(["true", "false"]);
    const [keypadEnabled, setKeypadEnabled] = useState(false);
    const [accessPoints, setAccessPoints] = useState([]);
    const [selectedAccessPoints, setSelectedAccessPoints] = useState([]);
    const { accessIssue, clearAccessIssue, handleAccessError } = usePageAccessRedirect({
        deniedTitle: 'Groups Access Denied',
        deniedMessage: 'You do not have permission to view or manage groups for this location.',
    });

    useEffect(() => {
        const fetchGroups = async () => {
            await getGroups();
            await getAccessPoints();
          };
      
          fetchGroups();
        //   returnTable
    }
    , [typeId, relayStatus]);

    const getGroups = async () => {
        clearAccessIssue();
        setLoading(true);
        const token = localStorage.getItem('token');
        let header = {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }

        axios.get(`${global.config.url}/groups/location/${typeId}`, header)
            .then(response => {
                setGroups(response.data);
                setLoading(false);
            })
            .catch(async error => {
                if (handleAccessError(error)) {
                    setLoading(false);
                    return;
                }
                setError(error.message);
                setLoading(false);
            })
        // axios.get(`${global.config.url}/ajaxrelay/status/${typeId}`, header)
        // .then(response => {
        //     console.log(response.data);
        //     setRelayStatus(response.data);
        // })
        // .catch(async error => {
        //     if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        //         setShowLoginModal(true);
        //     }
        //     setError(error.message);
        // })
    }


    const getAccessPoints = async () => {
        try {
          setLoading(true);
          setAccessPoints([]);
          const token = localStorage.getItem('token');
          let header = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
          const response = await axios.get(global.config.url + `/accesspoints/ByLocation/${typeId}`, header);
            setAccessPoints(response.data);
            setLoading(false);
        } catch (error) {
                    if (handleAccessError(error, { deniedMessage: 'You do not have permission to view access points for this location.' })) {
                            return;
                        }
        }
      };


    const handleAdd = () => {
        setNewHubRelay(true);
        setHubRelay({});
        setSubmitted(false);
        setDisplayDialog(true);
    }

    const onRowEditComplete = (rowData) => {
        setNewGroupName(rowData.newData.name);
        setDeniedResponse(rowData.newData.extra);
        setNewBlockingTime(rowData.newData.blockingTime);
        let blockingGroupNames = rowData.newData.blockedBy.split(';');
        let blockingGroups = [];
        blockingGroupNames.forEach(name => {
            let group = groups.find(g => g.name === name);
            if (group) {
                blockingGroups.push(group);
            }
        });
        setBlockingGroups(blockingGroups);
        setEditGroupId(rowData.newData.id);
        setNewHubRelay(true);
        setHubRelay({});
        setSubmitted(false);
        setDisplayDialog(true);
    }


    const selectGroupToEdit = (rowData) => {
        setSelectedGroup(rowData);
        setNewGroupName(rowData.name);
        setDeniedResponse(rowData.extra);
        setNewBlockingTime(rowData.blockingTime);
        let blockingGroupNames = rowData.blockedBy.split(';');
        let blockingGroupsIds = [];
        blockingGroupNames.forEach(name => {
            let group = groups.find(g => g.name === name);
            if (group) {
                blockingGroupsIds.push(group.id.toString());
            }
        });
        setBlockingGroups(blockingGroupsIds);
        let accessPointsNames = rowData.accessPoints.split(';');
        let accessPointsIds = [];
        accessPointsNames.forEach(name => {
            let ap = accessPoints.find(a => a.gate === name);
            if (ap) {
                accessPointsIds.push(ap.id.toString());
            }
        });
        setSelectedAccessPoints(accessPointsIds);
        setEditGroupId(rowData.id);
        setNewHubRelay(true);
        setHubRelay({});
        setSubmitted(false);
        setDisplayDialog(true);
    }

    const confirm = (create, newdata) => {
        if(create === null){
          toastBC.current.show({
            severity: 'info',
            sticky: true,
            className: 'border-none',
            content: (
                <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                    <div className="text-center">
                        <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                        <div className="font-bold text-xl my-3">Are you sure?</div>
                    </div>
                    <div className="flex align-items-center">
                        <Button onClick={(e) => handleSave(newdata)} type="button" label="Confirm" className="p-button-success w-6rem" />
                        <Button onClick={(e) => handleCancel()} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                    </div>
                </div>
            )
          });
        }
        else{
          if(create){
            if(newGroupName === null || newGroupName  === undefined || newGroupName === ''){
              toast.current.show({severity: 'error', summary: '', detail: 'Please enter a new name.'});
              return;
            }
            if(deniedResponse === null || deniedResponse === undefined || deniedResponse === ''){
              toast.current.show({severity: 'error', summary: '', detail: 'Please enter a Denied Response.'});
              return;
            }
            console.log(newBlockingTime);
            if (isNaN(newBlockingTime) || newBlockingTime < 1 || newBlockingTime % 1 !== 0) {
                toast.current.show({ severity: 'error', summary: '', detail: 'Blocking Time must be a non decimal number higher than 0', life: 3000 });
                return;
            }
            toastBC.current.show({
              severity: 'info',
              sticky: true,
              className: 'border-none',
              content: (
                  <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                      <div className="text-center">
                          <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                          <div className="font-bold text-xl my-3">Are you sure?</div>
                      </div>
                      <div className="flex align-items-center">
                          <Button onClick={(e) => handleSave(null)} type="button" label="Confirm" className="p-button-success w-6rem" />
                          <Button onClick={(e) => handleCancel()} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                      </div>
                  </div>
              )
            });
          }
          else{
            setDeleteLoading(true);
            toastBC.current.show({
              severity: 'info',
              sticky: true,
              className: 'border-none',
              content: (
                  <div className="flex flex-column align-items-center" style={{ flex: '1' }}>
                      <div className="text-center">
                          <i className="pi pi-exclamation-triangle" style={{ fontSize: '3rem' }}></i>
                          <div className="font-bold text-xl my-3">Are you sure?</div>
                      </div>
                      <div className="flex align-items-center">
                          <Button onClick={(e) => handleDelete()} type="button" label="Confirm" className="p-button-success w-6rem" />
                          <Button onClick={(e) => handleDeleteCancel()} type="button" label="Cancel" className="p-button-warning w-6rem mx-4" />
                      </div>
                  </div>
              )
            });
          }
        }
      
      };

    const handleSave = (newData) => {
        toastBC.current.clear();
        setSubmitted(true);
        setLoading(true);
        let token = localStorage.getItem('token');
        let header = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        let blockingGroupIds = blockingGroups.filter(id => id !== "").map(id => parseInt(id));
        let accessPointIds = selectedAccessPoints.filter(id => id !== "").map(id => parseInt(id));
        if(accessPointIds.length === 0){
            toast.current.show({ severity: 'error', summary: '', detail: 'Please select at least one Access Point', life: 3000 });
            setLoading(false);
            return;
        }
          
        console.log(selectedAccessPoints)
        console.log(accessPointIds)
          if(editGroupId === 0)
            {
                let group = {
                    "id": 0,
                    "name": newGroupName,
                    "blockedBy": blockingGroupIds,
                    "locationId": typeId,
                    "extra": deniedResponse,
                    "blockingTime": newBlockingTime,
                    "accessPointIds": accessPointIds
                }
                console.log(group);
                axios.post(`${global.config.url}/groups`, group, header)
                .then(response => {
                    // setSuccess('HubRelay added successfully');
                    msgs.current.show({ severity: 'success', summary: '', detail: 'Group Created', life: 3000 });
                    getGroups();
                    setNewGroupName('');
                    setDeniedResponse('Your access has been blocked by the Anti-passback rule.');
                    setNewBlockingTime(0);
                    setBlockingGroups([]);
                    setDisplayDialog(false);
                    setSelectedAccessPoints([]);

                })
                .catch(error => {
                    if(error.response && error.response.status === 400){
                        toast.current.show({ severity: 'error', summary: '', detail: error.response.data, life: 3000 });
                        setLoading(false);
                        return;
                    }
                    else if(error.response && error.response.status === 401){
                        handleAccessError(error, { deniedMessage: 'You do not have permission to create groups for this location.' });
                        setLoading(false);
                        return;
                    }
                    else{
                        toast.current.show({ severity: 'error', summary: '', detail: 'Group Creation Failed', life: 3000 });
                        setLoading(false);
                        return;
                    }
                })
            }
            else
            {
                let group = {
                    "id": editGroupId,
                    "name": newGroupName,
                    "blockedBy": blockingGroupIds,
                    "locationId": typeId,
                    "extra": deniedResponse,
                    "blockingTime": newBlockingTime,
                    "accessPointIds": accessPointIds
                }

                console.log(group);
                axios.put(`${global.config.url}/groups/${editGroupId}`, group, header)
                    .then(response => {
                        msgs.current.show({ severity: 'success', summary: '', detail: 'Group Updated', life: 3000 });
                        getGroups();
                        setNewGroupName('');
                        setDeniedResponse('Your access has been blocked by the Anti-passback rule.');
                        setNewBlockingTime(0);
                        setBlockingGroups([]);
                        setEditGroupId(0);
                        setDisplayDialog(false);
                        setSelectedAccessPoints([]);
                        toastBC.current.clear();
                    })
                    .catch(error => {
                        if(error.response && error.response.status === 400){
                            toast.current.show({ severity: 'error', summary: '', detail: error.response.data, life: 3000 });
                            setLoading(false);
                            return;
                        }
                        else if(error.response && error.response.status === 401){
                            handleAccessError(error, { deniedMessage: 'You do not have permission to update this group.' });
                            setLoading(false);
                            return;
                        }
                        else{
                            toast.current.show({ severity: 'error', summary: '', detail: 'Group Update Failed', life: 3000 });
                            setLoading(false);
                            return;
                        }
                    })
            }
    }

    const handleDelete = () => {
        console.log(selectedGroup);
        toastBC.current.clear();
        if(selectedGroup === null || selectedGroup === undefined || selectedGroup.id === 0){
            msgs.current.show({severity: 'error', summary: '', detail: 'Please select a group to delete.'});
            setLoading(false);
            setDeleteLoading(false);
            return;
        }
        let token = localStorage.getItem('token');
        let header = {
            headers: {
            Authorization: `Bearer ${token}`,
            },
        }
        setLoading(true);
        axios.delete(`${global.config.url}/groups/${selectedGroup.id}`, header)
            .then(response => {
                msgs.current.show({ severity: 'success', summary: '', detail: 'Group Deleted', life: 3000 });
                getGroups();
                setSelectedGroup(null);
                setDisplayDialog(false);
                setNewGroupName('');
                setDeniedResponse('Your access has been blocked by the Anti-passback rule.');
                setNewBlockingTime(0);
                setBlockingGroups([]);
                setEditGroupId(0);
                setDisplayDialog(false);
                setSelectedAccessPoints([]);
            })
            .catch(error => {
                msgs.current.show({ severity: 'error', summary: '', detail: 'Group Deletion Failed', life: 3000 });
            })
            setLoading(false);
            setDeleteLoading(false);
            toastBC.current.clear();
    }


    const handleCancel = () => {
  
        toastBC.current.clear();
        setLoading(false);
        setDisplayDialog(false);
        setNewGroupName('');
        setDeniedResponse('Your access has been blocked by the Anti-passback rule.');
        setNewBlockingTime(0);
        setBlockingGroups([]);
        setEditGroupId(0);
        setSelectedAccessPoints([]);
    }

    // const handleInputChange = (event) => {
    //     const { name, value } = event.target;
    //     setHubRelay({ ...hubRelay, [name]: value });
    // }



    const handleDeleteConfirm = (rowData) => {
        setSelectedGroup(rowData);
        setDisplayDialogDelete(true);
    }

    const handleDeleteCancel = () => {
  
        setSelectedGroup(null);
        setDisplayDialog(false);
        toastBC.current.clear();
    }

    const endContent = (
        <React.Fragment>
            <span className="p-input-icon-left mr-3 mt-1">
                <i className="pi pi-search" />
                <InputText type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Search..." />
                <Button icon="pi pi-refresh" className="p-button-text" onClick={() => getGroups()} disabled={loading} tooltip="Refresh groups" tooltipOptions={{position: "bottom"}}/>
                <Button icon="pi pi-plus" className="p-button-success p-mr-2" rounded loading={loading} disabled={loading} onClick={handleAdd} tooltip='Add a new group'/>
            </span>
        </React.Fragment>
    );

    const newGroupDialogFooter = (
        <div>
            <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={handleCancel} />
            <Button label='Delete' icon="pi pi-trash" className="p-button-danger" loading={deleteLoading} disabled={loading} onClick={() => confirm(false)} tooltip="Delete selected group" tooltipOptions={{position: "bottom"}} />
            <Button label="Save" icon="pi pi-check" className="p-button-success" onClick={() => confirm(true, null)} />
        </div>
    );

    const deleteHubRelayDialogFooter = (
        <div>
            <Button label="No" icon="pi pi-times" className="p-button-text" onClick={handleDeleteCancel} />
            <Button label="Yes" icon="pi pi-check" className="p-button-text" onClick={handleDelete} />
        </div>
    );

    const getSeverity = (option) => {
        switch (option) {
            case true:
                return 'success';
    
            case false:
                return 'danger';
    
            case null: 
                return 'warning';
            default:
                return null;
        }
    };

    const allowedBodyTemplate = (ajax) => {
        return <Tag value={ajax.allowed ? "Allowed" : "Not Allowed"} severity={getSeverity(ajax.allowed)}></Tag>;
    };

    const statusBodyTemplate = (relay) => {
        let value = "";
        console.log(relay.status);
        switch(relay.status){
            case true:
                value = "Online";
                break;
            case false:
                value = "Offline";
                break;
            default:
                value = "Unknown";
                break;
        }
        return <Tag value={value} severity={getSeverity(relay.status)}></Tag>;
    };
    const hubStatusBodyTemplate = (relay) => {
        let value = "";
        console.log(relay.hubStatus);
        switch(relay.hubStatus){
            case true:
                value = "Online";
                break;
            case false:
                value = "Offline";
                break;
            default:
                value = "Unknown";
                break;
        }
        return <Tag value={value} severity={getSeverity(relay.hubStatus)}></Tag>;
    };

    const textEditor = (options) => {
        console.log(options);
        return <InputText type="text" value={options.value} onChange={(e) => options.editorCallback(e.target.value)} />;
    };

    const allowedEditor = (options) => {
        // console.log(options);
        return <Dropdown
            value={options.rowData.allowed}
            options={statuses}
            onChange={(e) => options.editorCallback(e.value === 'true')}
            placeholder="Select Allowance"
            itemTemplate={(option) => {
                return <Tag value={option} severity={getSeverity(option)}></Tag>;
            }}
        />;
    };
    
    const updateRelayId = (value) => {
        // setNewRelayId(value);
        console.log(value);
    }

    const addBlockingGroup = () => {console.log(blockingGroups);  setBlockingGroups([...blockingGroups, ""]); }
    const removeBlockingGroup = (index) =>
        setBlockingGroups(blockingGroups.filter((_, i) => i !== index));

    const updateBlockingGroup = (index, value) => {
        const updated = [...blockingGroups];
        updated[index] = value;
        setBlockingGroups(updated);
    };

    const updateAccessPoint = (index, value) => {
        const updated = [...selectedAccessPoints];
        updated[index] = value;
        setSelectedAccessPoints(updated);
    };

    const addAccessPoint = () => { setSelectedAccessPoints([...selectedAccessPoints, ""]); }
    const removeAccessPoint = (index) =>
        setSelectedAccessPoints(selectedAccessPoints.filter((_, i) => i !== index));

    if (accessIssue) {
        return <AccessState {...accessIssue} />;
    }

    return (
        <Card className ="justify-content-md-center mx-5">
            <Container >
            <div className="card">
                <Toolbar 
                    start={
                    <Container className="flex align-content-center flex-wrap">
                        <Button link icon="pi pi-arrow-left" onClick={() => navigate(-1)} className='flex'/> 
                        <h4 className='flex mt-2'>Groups</h4> 
                    </Container>}
                    end={endContent}/>
                </div>
                <Messages ref={msgs} />
                <Toast ref={toastBC} position="top-center" />
                <div className='justify-content-md-center mt-3'>
                    <DataTable 
                        // ref={dt} 
                        value={groups} selectionMode='single' selection={selectedGroup} onSelectionChange={(e) => selectGroupToEdit(e.value)}
                        dataKey="id"
                        // globalFilter={globalFilter}
                        editMode='row' onRowEditComplete={onRowEditComplete}> 
                        <Column field="name" header="Group Name" sortable editor={(options) => textEditor(options)}/>
                        <Column field="blockedBy" header="Blocked By" sortable/>
                        <Column field="blockingTime" header="Blocking Time"></Column>
                        <Column field="accessPoints" header="Access Points"></Column>
                        <Column field="extra" header="Denied Response" editor={(options) => textEditor(options)}></Column>
                        {/* <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }} onClick={onRowEditComplete}></Column> */}
                    </DataTable>
                </div>
            </Container>
            <Dialog visible={displayDialog} style={{ width: '450px' }} header="Group Details" modal className="p-fluid" footer={newGroupDialogFooter} onHide={handleCancel}>
                <Toast ref={toast} />
                <div className="p-field">
                    <label htmlFor="name">Name</label>

                    <InputText id="name" name="name" value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)} required autoFocus  />
                    {submitted && !newGroupName && <small className="p-invalid">Name is required.</small>}
                </div>
                <div className="p-field mt-3">
                    <label htmlFor="extra">Denied Response</label>
                    <InputText id="extra" name="extra" value={deniedResponse} onChange={(e) => setDeniedResponse(e.target.value)} required  />
                    {submitted && !deniedResponse && <small className="p-invalid">Denied Response is required.</small>}
                </div>
                <div className="p-field mt-3">
                    <label htmlFor="blockingTime">Blocking Time (minutes)</label>
                    <InputText id="blockingTime" name="blockingTime" value={newBlockingTime} onChange={(e) => setNewBlockingTime(e.target.value)} required  />
                    {submitted && !newBlockingTime && <small className="p-invalid">Blocking Time is required.</small>}
                </div>
                {/* Blocking Groups */}
                <div className="mb-4">
                <label className="block text-sm font-medium mb-1">
                    Blocked by Groups
                </label>
                <div className="space-y-2">
                    {blockingGroups.map((selected, i) => (
                    <div key={i} className="flex items-center gap-2">
                        <select
                        className="flex-1 border rounded-lg p-2"
                        value={selected}
                        onChange={(e) => updateBlockingGroup(i, e.target.value)}
                        >
                            {selected === "" && <option value="">-- Select a group --</option>}
                        {//if selected is not empty, show selected.name as the first option
                        selected !== "" && <option value={selected.id}>{selected.name}</option>
                        }
                        {groups.map((g) => (
                            <option key={g.id} value={g.id}>
                            {g.name}
                            </option>
                        ))}
                        </select>
                        <button
                        type="button"
                        onClick={() => removeBlockingGroup(i)}
                        className="px-2 py-1 text-sm bg-red-100 text-red-600 rounded-lg hover:bg-red-200"
                        >
                        Remove
                        </button>
                    </div>
                    ))}

                    <button
                    type="button"
                    onClick={addBlockingGroup}
                    className="text-blue-600 text-sm mt-2 hover:underline"
                    >
                    + Add another blocking group
                    </button>

                </div>
                </div>
                {/* Choose accesspoints*/}
                <div className="mb-4">
                    <label className="block text-sm font-medium mb-1">
                        Access Points
                    </label>
                    <div className="space-y-2 max-h-40 overflow-y-auto border p-2 rounded">
                        {selectedAccessPoints.map((selected, i) => (
                            <div key={i} className="flex items-center gap-2">
                                <select className="flex-1 border rounded-lg p-2"
                                    value={selected}
                                    onChange={(e) => updateAccessPoint(i, e.target.value)}
                                >
                                    {selected === "" && <option value="">-- Select an access point --</option>}
                                    {selected !== "" && <option value={selected.id}>{selected.gate}</option>}
                                    {accessPoints.map((ap) => (
                                        <option key={ap.id} value={ap.id}>
                                            {ap.gate}
                                        </option>
                                    ))}
                                </select>
                                <button type="button" onClick={() => removeAccessPoint(i)} className="px-2 py-1 text-sm bg-red-100 text-red-600 rounded-lg hover:bg-red-200">
                                    Remove
                                </button>
                            </div>
                        ))}
                        <button type="button" onClick={addAccessPoint} className="text-blue-600 text-sm mt-2 hover:underline">
                            + Add another access point
                        </button>
                    </div>
                    
                </div>
            </Dialog>
            <Dialog visible={displayDialogDelete} style={{ width: '450px' }} header="Confirm" modal footer={deleteHubRelayDialogFooter} onHide={handleDeleteCancel}>
                <div className="confirmation-content">
                    <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
                    {hubRelay && <span>Are you sure you want to delete <b>{hubRelay.ajaxrelayid}</b>?</span>}
                </div>
            </Dialog>
        </Card>
    );
}

export default Groups;



